import { bindable } from 'aurelia-framework';
import * as DevExtreme from 'devextreme/dist/js/dx.all';
import { jsPDF } from 'jspdf';
import { exportDataGrid as exportDataGridToPdf} from 'devextreme/pdf_exporter';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import { exportDataGrid } from 'devextreme/excel_exporter';

export class GridControl {
    @bindable items = null;
    @bindable columns;
    @bindable filterVisible = false;
    @bindable searchPanelVisible = false;
    @bindable onCellPrepared;
    @bindable onRowUpdating;
    @bindable onRowPrepared;
    @bindable onEditorPreparing;
    @bindable columnAutoWidth = true;
    @bindable service;
    @bindable export;
    @bindable masterDetail = {};
    @bindable selectionEnabled = false;
    @bindable extraParams = '';
    @bindable height = 'auto';
    @bindable filterMethod = 'filter';
    @bindable id = '';
    @bindable contentReady;
    @bindable paging = false;

    attached() {
        let dataSource = {};
        if (this.service) {
            dataSource = new DevExpress.data.DataSource({
                load: async (loadOptions) => await this.service[this.filterMethod](JSON.stringify(loadOptions), this.extraParams)
            });
        }

        if (this.items != null) {
            dataSource = new DevExpress.data.DataSource({
                load: () => this.items
            });
        }

        this.dataGrid = $(this.control).dxDataGrid({
            filterRow: { visible: this.filterVisible },
            searchPanel: { visible: this.searchPanelVisible, width: 300 },
            dataSource: dataSource,
            masterDetail: this.masterDetail,
            columnAutoWidth: this.columnAutoWidth,
            stateStoring: {
                enabled: true,
                type: 'localStorage',
                storageKey: this.id
            },
            selection: {
                mode: this.selectionEnabled ? 'multiple' : 'none'
            },
            export: {
                enabled: this.export,
                formats: ['xlsx', 'pdf'],
                ignoreExcelErrors: true
            },
            onExporting: async (e) => {
                if (e.format === 'xlsx') {
                    const workbook = new Workbook();
                    const worksheet = workbook.addWorksheet('Data');
                    await exportDataGrid({
                        component: e.component,
                        worksheet,
                        autoFilterEnabled: true
                    });
                    const buffer = await workbook.xlsx.writeBuffer();
                    saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'Data.xlsx');
                } else if(e.format === 'pdf') {
                    const doc = new jsPDF();
                    await exportDataGridToPdf({
                        jsPDFDocument: doc,
                        component: e.component
                    });
                    doc.save('Data.pdf');
                }
            },
            remoteOperations: this.items != null ? false : {
                filtering: true,
                sorting: true,
                paging: true,
                grouping: false,
                summary: false
            },
            scrolling: {
                mode: this.paging ? 'standard' : (this.items != null ? 'virtual' : 'infinite'),
            },
            paging: {
                enabled: this.items != null || this.paging,
                pageSize: 20,
            },
            pager: {
                visible: this.paging,
                showPageSizeSelector: this.paging,
                allowedPageSizes: [10, 20, 50],
            },
            height: this.items != null ? this.height : `auto`,
            showBorders: true,
            columns: this.columns,
            onCellPrepared: this.onCellPrepared,
            onRowUpdating: this.onRowUpdating,
            onContentReady: (e) => {
                $(".dx-datagrid-table").addClass("table table-borderless");
                e.element.find(".dx-datagrid-text-content").removeClass("dx-text-content-alignment-left");
                if (this.contentReady != null) {
                    this.contentReady();
                }
            },
            onRowPrepared: this.onRowPrepared,
            onRowExpanding: this.onRowExpanding,
            onEditorPreparing: this.onEditorPreparing
        });
    }

    refresh() {
        if(this.currentExpandedRow) {
            $(this.control).dxDataGrid('collapseRow', this.currentExpandedRow);
        }
        const dataGrid = $(this.control).dxDataGrid('instance');
        dataGrid.refresh();
    }

    onRowExpanding = (e) => {
        if(this.currentExpandedRow) {
            $(this.control).dxDataGrid('collapseRow', this.currentExpandedRow);
        }
        this.currentExpandedRow = e.key;
    };

    getSelectedRows () {
        const dataGrid = $(this.control).dxDataGrid('instance');
        return dataGrid.getSelectedRowsData();
    }

    getFilter () {
        const dataGrid = $(this.control).dxDataGrid('instance');
        const filter = dataGrid.getCombinedFilter(true);
        if (filter != null && filter.length > 0) {
            if (filter[0].length > 0) {
                return filter[0][2];
            }
        }
        
        return '';
    }

    getVisibleRows() {
        const dataGrid = $(this.control).dxDataGrid('instance');
        return dataGrid.getVisibleRows();
    }

    repaintRows(rowIndex) {
        const dataGrid = $(this.control).dxDataGrid('instance');
        dataGrid.repaintRows(rowIndex);
    }

    getRowElement(rowIndex) {
        const dataGrid = $(this.control).dxDataGrid('instance');
        return dataGrid.getRowElement(rowIndex);
    }
}
